import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { toDisplayTimeString } from '../../helpers/moment-ex';
import DeviceInfo from './DeviceInfo';
import { DataTable } from '../widgets/DataTable';
import { NOT_APPLICABLE } from '../../constants';
import CommandAssignForm from './CommandAssignForm';
import { usePermission } from '../../helpers/common';
import { LoadingStyle } from './utils';
import { Unit } from '../../helpers/unit';
import { toastError, toastSuccess } from '../../actions/toast';
import { archiveDevice, unArchiveDevice, updateHardwareList } from '../../actions/hardware';
import { Modal } from 'react-bootstrap';

const DeviceRowV1 = (props) => {
    const { item, index, isRequesting, farmId, selectedViewType, deviceList, allowEdit } = props;

    const [modalInfo, setModalInfo] = useState({
        command: { show: false, deviceId: null, deviceName: "" },
        hardware: { show: false, hardwareId: null },
        archive: false,
        restore: false,
    });

    const dispatch = useDispatch();
    const unit = Unit.getInstance();
    const allow = usePermission();
    const isAllowCreate = allow("device", "create") ? true : false;
    const cpuIcon = require("../../../assets/images/ic_cpu.svg");
    const isActive = modalInfo.command.show || modalInfo.hardware.show;

    const Unavailable = <span className="un-available">{NOT_APPLICABLE}</span>;

    const formatNetworkConnection = (value) => {
        if (value === NOT_APPLICABLE)
            return Unavailable;
        else if (value === true)
            return <span className="badge badge-pill badge-success badge-sm">Connected</span>;
        else return <span className="badge badge-pill badge-danger badge-sm">Disconnected</span>;
    };

    const formatNetworkLinkUptime = (value) => {
        const connected = formateData("networkLinkStatus");
        if (connected === true)
            return <span>{toDisplayTimeString(value)} <i className="fa fa-arrow-up" style={{ fontSize: '12px', color: 'green' }} /></span>;
        else if (connected === NOT_APPLICABLE)
            return Unavailable
        else return <span>{toDisplayTimeString(value)} <i className="fa fa-arrow-down" style={{ fontSize: '12px', color: 'red' }} /></span>;
    };

    const formatCanConnection = (value) => {
        if (value === 1)
            return <span className="badge badge-pill badge-danger badge-sm">Disconnected</span>;
        else if (value === 2)
            return <span className="badge badge-pill badge-warning badge-sm">Needs Attention</span>;
        else if (value === 3)
            return <span className="badge badge-pill badge-success badge-sm">Connected</span>;
        else return Unavailable;
    };

    const formatBatteryInfo = (value) => {
        return value ? `${unit.toFixedOf(value, 2)}%` : `0%`;
    };

    const handleCommandModal = (type, show, id, name) => {
        setModalInfo({ ...modalInfo, [type]: { show, deviceId: id ? id : null, deviceName: name ? name : "" } });
    };

    const handleHardwareModal = (type, show, item) => {
        setModalInfo({ ...modalInfo, [type]: { show, item } });
    };

    const formateData = (key) => {
        let value = item[key] ? item[key] : null;
        return value === 0 ? 0 : value;
    }

    const copyTextToClipboard = async (text) => {
        if ('clipboard' in navigator) {
            await navigator.clipboard.writeText(text);
            return dispatch(toastSuccess(`${text} copied`));
        } else {
            return dispatch(toastError(`couldn't copy`));
        }
    }

    const handleDeviceStatus = (deviceId, archiveDevice = true) => {
        if (archiveDevice) {
            props.actions.archiveDevice({ farm_uuid: farmId, device_uuid: deviceId }, () => {

                const updatedDeviceList = deviceList.map(e => {
                    if (e.deviceId === deviceId) return { ...e, statusId: 2 };
                    return e;
                });

                props.actions.updateHardwareList(updatedDeviceList);
            })
        }
        else {
            props.actions.unArchiveDevice({ farm_uuid: farmId, device_uuid: deviceId }, () => {
                const updatedDeviceList = deviceList.map(e => {
                    if (e.deviceId === deviceId) return { ...e, statusId: 1 };
                    return e;
                });

                props.actions.updateHardwareList(updatedDeviceList);
            })
        }
    }

    return (
        <>
            <DataTable.Row className={`item ${isActive && "active"}`}>
                <DataTable.Cell style={{ width: "40px", textAlign: "center" }}>{index}</DataTable.Cell>
                <DataTable.Cell style={{ width: "130px" }} title={item.deviceId}>
                    {item.deviceName}
                    {
                        <span className="float-right ml-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => copyTextToClipboard(item.deviceId)}
                        > <i className='fa fa-clone' /></span>
                    }
                    {isAllowCreate && item.deviceId && <span
                        className="float-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCommandModal("command", true, item.deviceId, item.deviceName)}>
                        <img className="icon-cpu pr-1" src={cpuIcon} title="Send command" alt="Send command" />
                    </span>}
                </DataTable.Cell>
                <DataTable.Cell style={{ width: "130px" }}>{item.hardwareTypeName}</DataTable.Cell>
                <DataTable.Cell style={{ width: "145px" }}>{item.egName && item.egName !== NOT_APPLICABLE ? item.egName : ""}</DataTable.Cell>
                <DataTable.Cell style={{ width: "170px" }}>{item.operatorName && item.operatorName !== NOT_APPLICABLE ? item.operatorName : ""}</DataTable.Cell>
                <DataTable.Cell style={{ width: "160px" }}>{item.model || Unavailable}</DataTable.Cell>
                <DataTable.Cell style={{ width: "160px" }}>{item.imei || Unavailable}</DataTable.Cell>
                <DataTable.Cell style={{ width: "125px" }}>{item.appVersion || Unavailable}</DataTable.Cell>
                <DataTable.Cell style={{ width: "140px" }}>{item.networkName || Unavailable}</DataTable.Cell>
                <DataTable.Cell style={{ width: "125px", textAlign: 'center' }}>
                    {isRequesting ? <LoadingStyle /> : formatNetworkConnection(formateData("networkLinkStatus"))}</DataTable.Cell>
                <DataTable.Cell style={{ width: "140px", textAlign: 'center' }}>
                    {isRequesting ? <LoadingStyle /> : formatNetworkLinkUptime(formateData("networkLinkTime"))}</DataTable.Cell>
                <DataTable.Cell style={{ width: "160px", textAlign: 'start' }}>{item.canCode || Unavailable}</DataTable.Cell>
                <DataTable.Cell style={{ width: "125px", textAlign: 'start' }}>
                    {isRequesting ? <LoadingStyle /> : formatCanConnection(formateData("canInterface"))}</DataTable.Cell>
                <DataTable.Cell style={{ width: "80px", textAlign: 'center' }}>
                    {isRequesting ? <LoadingStyle /> : formatBatteryInfo(formateData("battery"))}</DataTable.Cell>
                <DataTable.Cell style={{ width: "110px", textAlign: 'center' }}>
                    <>
                        <i
                            title="See Details"
                            className="fa fa-cogs"
                            style={{ cursor: "pointer" }}
                            aria-hidden="true"
                            onClick={() => handleHardwareModal("hardware", true, item)} />

                        {allowEdit &&
                            <>
                                {selectedViewType === 1 ?
                                    <i
                                        title="Archive"
                                        aria-hidden="true"
                                        style={{ cursor: "pointer" }}
                                        className="fa fa-trash cursor-pointer fa-lg pl-3"
                                        onClick={() => setModalInfo({ ...modalInfo, archive: true })} />
                                    :
                                    <i className="fa fa-undo cursor-pointer fa-lg pl-3"
                                        title="Un-archive"
                                        style={{ cursor: "pointer" }} aria-hidden="true"
                                        onClick={() => setModalInfo({ ...modalInfo, restore: true })} />}
                            </>}
                    </>

                </DataTable.Cell>
            </DataTable.Row>
            {(modalInfo.hardware.item || {}).hardwareId &&
                <DeviceInfo
                    show={modalInfo.hardware.show}
                    farmId={farmId}
                    onHide={() => handleHardwareModal("hardware", false)}
                    item={modalInfo.hardware.item} />}
            {modalInfo.command.deviceId &&
                <CommandAssignForm
                    modalInfo={modalInfo.command}
                    onHide={() => handleCommandModal("command", false)} />}

            <Modal.Confirm
                className="modal-bordered"
                show={modalInfo.archive}
                onConfirm={() => handleDeviceStatus(item.deviceId, true)}
                onHide={() => setModalInfo({ ...modalInfo, archive: false })}
                title={{ content: "Remove Device" }}
                content={`Do you want to archive device ${item.deviceName}?`}
                confirmButton={{ content: 'Archive' }}
                cancelButton={{ content: 'Cancel' }}
                iconClassName={'fa fa-trash'}
            />

            <Modal.Confirm
                className="modal-bordered"
                show={modalInfo.restore}
                onConfirm={() => handleDeviceStatus(item.deviceId, false)}
                onHide={() => setModalInfo({ ...modalInfo, restore: false })}
                title={{ content: "Restore Device" }}
                content={`Do you want to restore device ${item.deviceName}?`}
                confirmButton={{ content: 'Restore' }}
                cancelButton={{ content: 'Cancel' }}
                iconClassName={'fa fa-undo'}
            />
        </>);
}

const mapStateToProps = state => ({
    isRequesting: state.hardware.sensorListById.isRequesting
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ archiveDevice, unArchiveDevice, updateHardwareList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceRowV1);